import { render, staticRenderFns } from "./YouthStatistical.vue?vue&type=template&id=799f7d2f&scoped=true&"
import script from "./YouthStatistical.vue?vue&type=script&lang=js&"
export * from "./YouthStatistical.vue?vue&type=script&lang=js&"
import style0 from "./YouthStatistical.vue?vue&type=style&index=0&id=799f7d2f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799f7d2f",
  null
  
)

export default component.exports